export const vi = {
  title: 'Sao lưu',
  description:
    'Cơ sở dữ liệu được sao lưu liên tục, dữ liệu và file được chụp mỗi giờ, và được khôi phục thử mỗi tháng. Bản sao được mã hoá và lưu ngoài máy chủ.',
  notInstalled: 'Chưa có dữ liệu sao lưu',
  notInstalledHint:
    'Dịch vụ sao lưu chạy trên máy chủ (container backup). Khi chạy, mỗi lần sao lưu và diễn tập khôi phục sẽ hiện ở đây.',
  loadError: 'Không tải được tình trạng sao lưu',
  retry: 'Thử lại',
  kind: {
    pitr: 'Sao lưu liên tục',
    snapshot: 'Bản chụp dữ liệu và file',
    drill: 'Diễn tập khôi phục',
  },
  schedule: {
    pitr: 'Ghi nhận thay đổi liên tục, bản sao lưu đầy đủ mỗi đêm',
    snapshot: 'Mỗi giờ, giữ 24 giờ, 7 ngày, 4 tuần, 12 tháng',
    drill: 'Ngày 1 hằng tháng',
  },
  state: { ok: 'Ổn định', stale: 'Quá hạn', failed: 'Lỗi', never: 'Chưa chạy' },
  status: { running: 'Đang chạy', succeeded: 'Thành công', failed: 'Thất bại' },
  lastSuccess: 'Thành công gần nhất',
  neverSucceeded: 'Chưa thành công lần nào',
  restorableFrom: 'Khôi phục được về mọi thời điểm từ',
  databaseSize: 'Dung lượng cơ sở dữ liệu',
  dumpSize: 'Bản dump',
  files: 'File tải lên',
  restoreTime: 'Thời gian khôi phục',
  dataUpTo: 'Dữ liệu khôi phục được đến',
  tables: 'Số bảng',
  offsite: 'Lưu ngoài máy chủ',
  localOnly: 'Chỉ lưu trên máy chủ',
  runs: 'Các lần chạy',
  allKinds: 'Mọi loại',
  type: 'Loại',
  started: 'Bắt đầu',
  duration: 'Thời lượng',
  size: 'Dung lượng',
  note: 'Ghi chú',
  details: 'Chi tiết',
  output: 'Thông báo lỗi',
  noRuns: 'Chưa có lần chạy nào',
  seconds: '{{count}} giây',
  minutes: '{{count}} phút',
};

export const en: typeof vi = {
  title: 'Backups',
  description:
    'The database is backed up continuously, data and files are snapshotted hourly and restored as a test every month. Copies are encrypted and kept off the server.',
  notInstalled: 'No backup data yet',
  notInstalledHint:
    'The backup service runs on the server (backup container). Once it runs, every backup and restore drill shows up here.',
  loadError: 'Could not load the backup status',
  retry: 'Retry',
  kind: { pitr: 'Continuous backup', snapshot: 'Data and file snapshot', drill: 'Restore drill' },
  schedule: {
    pitr: 'Changes recorded continuously, full backup every night',
    snapshot: 'Hourly, kept 24 hours, 7 days, 4 weeks, 12 months',
    drill: '1st of every month',
  },
  state: { ok: 'Healthy', stale: 'Overdue', failed: 'Failed', never: 'Not run yet' },
  status: { running: 'Running', succeeded: 'Succeeded', failed: 'Failed' },
  lastSuccess: 'Last success',
  neverSucceeded: 'Never succeeded',
  restorableFrom: 'Restorable to any point since',
  databaseSize: 'Database size',
  dumpSize: 'Dump',
  files: 'Uploaded files',
  restoreTime: 'Restore time',
  dataUpTo: 'Data restored up to',
  tables: 'Tables',
  offsite: 'Kept off the server',
  localOnly: 'On the server only',
  runs: 'Runs',
  allKinds: 'All kinds',
  type: 'Kind',
  started: 'Started',
  duration: 'Duration',
  size: 'Size',
  note: 'Note',
  details: 'Details',
  output: 'Error output',
  noRuns: 'No runs yet',
  seconds: '{{count}} s',
  minutes: '{{count}} min',
};
